import { updateCurrentUser } from '@mews-commander/core';
import { GeneralArea, useRepositoryMutation } from '@mews-commander/data-access';

export const useDeleteProfilePhoto = () =>
    useRepositoryMutation('generalUsers', 'deleteImage', {
        transformParams: (_: void) => ({ application: GeneralArea.Commander }),
        onSuccess: () => {
            updateCurrentUser({ imageId: null });
        },
    });
